import React from 'react';
import { compose, setPropTypes } from 'recompose';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CancelButton from '../atoms/CancelButton';
import SubmitButton from '../atoms/SubmitButton';
import ImagePreview from './ImagePreview';

const styles = {
  paperWidthSm: {
    maxWidth: 325
  },
  tableCellItem: {
    borderBottom: '1px solid #DDDDDD',
    borderTop: '1px solid #DDDDDD',
    backgroundColor: '#F7F7F7',
    fontSize: 14,
    fontWeight: 'bold',
    padding: 10,
    // whiteSpace: 'nowrap',
    width: 100
  },
  tableCellData: {
    borderTop: '1px solid #DDDDDD',
    borderBottom: '1px solid #DDDDDD',
    padding: 10,
    fontSize: 14
  },
  detailTtl: {
    fontSize: 24,
    fontWeight: 700,
    color: '#333333',
    padding: '15px 10px 10px 0'
  },
  footerButton: {
    justifyContent: 'flex-start',
    marginBottom: 20,
    marginLeft: 20
  },
  inputArea: {
    boxSizing: 'border-box',
    padding: '0',
    gap: '10px',
    width: '100%',
    height: '150px',
    background: '#FFFFFF',
    border: 'none',
    '&:focus-visible': {
      outlineColor: '#2196F3'
    },
    '&:disabled': {
      opacity: 1,
      color: 'rgba(0, 0, 0, 0.87)',
      fontSize: 14
    },
    resize: 'none',
    marginTop: 3
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(setPropTypes(propTypes));

const Main = enhance(
  ({
    classes,
    openConfirm,
    updateOpenConfirm,
    okAction,
    isSmall,
    monthReport,
    previewImage1,
    textReport
  }) => {
    const cancelAction = () => updateOpenConfirm(false);
    const convertDateMonth = data => {
      const date = new Date(data);
      let month = date.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      const year = date.getFullYear();
      return `${year}/${month}`;
    };
    return (
      <Dialog
        open={openConfirm}
        onClose={() => {
          updateOpenConfirm(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={isSmall ? 'sm' : false}
        classes={{
          paperWidthSm: classes.paperWidthSm
        }}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="h6" className={classes.detailTtl}>
              運営報告 確認
            </Typography>
            <Paper className={classes.rootPaper}>
              <Table className={classes.detailTable}>
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      報告年月
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      {monthReport ? convertDateMonth(monthReport) : ''}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      コメント
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      <textarea
                        multiline
                        rows="4"
                        value={textReport.trim()}
                        className={classes.inputArea}
                        margin="normal"
                        disabled="true"
                      />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.tableCellItem}>
                      写真
                    </TableCell>
                    <TableCell className={classes.tableCellData}>
                      <ImagePreview previewImage={previewImage1 || null} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Paper>
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.footerButton}>
          <CancelButton
            onClickAction={cancelAction}
            color="default"
            btnText="戻る"
          />
          <SubmitButton onClickAction={okAction} btnText="投稿" />
        </DialogActions>
      </Dialog>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
